import loadable from '@loadable/component';

const RecentlyVisitedProductsLoader = loadable(
  () => import(/* webpackChunkName: "secondary-content" */ './recently-visited')
);

export default RecentlyVisitedProductsLoader;
